import { DeheadingReportingTypeEnum } from "@gtpl/shared-models/common-models";
import { QualityTypeEnum } from "libs/shared-models/common-models/src/lib/enum/supplier-type.enum";

export class WorkOrderLogReq{
    workOrderNo:string;
    date: Date;
    plantId:number;
    quantity:number;
    prodInvId?:number;
    remarks?:string;
    quality?:QualityTypeEnum;
    variantId?:number;
    variantName?:string;
    inInvId?:number
    outInvId?:number
     constructor(workOrderNo:string,date: Date,plantId:number,quantity:number,prodInvId?:number,remarks?:string,quality?:QualityTypeEnum,variantId?:number,variantName?:string,inInvId?:number,
    outInvId?:number){
        this.workOrderNo=workOrderNo;
        this.date=date;
        this.plantId=plantId;
        this.quantity=quantity;
        this.prodInvId=prodInvId;
        this.remarks=remarks;
        this.quality=quality;
        this.variantId=variantId;
        this.variantName=variantName;
        this.inInvId=inInvId;
        this.outInvId=outInvId
    }
}


export class DegummingReq{
    workOrderNo?:string;
    variantId?:number;
    quality?:number;
    outVariantId?:number
}

export class DegummingLogReq{
    workOrderNo:string;
    date: Date;
    plantId:number;
    quantity:number;
    prodInvId?:number;
    remarks?:string;
    quality?:QualityTypeEnum;
    variantId?:number;
    variantName?:string;
    createdUser?:string
     constructor(workOrderNo:string,date: Date,plantId:number,quantity:number,prodInvId?:number,remarks?:string,quality?:QualityTypeEnum,variantId?:number,variantName?:string,createdUser?:string){
        this.workOrderNo=workOrderNo;
        this.date=date;
        this.plantId=plantId;
        this.quantity=quantity;
        this.prodInvId=prodInvId;
        this.remarks=remarks;
        this.quality=quality;
        this.variantId=variantId;
        this.variantName=variantName;
        this.createdUser=createdUser
    }
}

export class DegummingOutputLogReq{
    workOrderNo:string;
    date: Date;
    plantId:number;
    quantity:number;
    prodInvId?:number;
    remarks?:string;
    quality?:QualityTypeEnum;
    variantId?:number;
    variantName?:string;
    reportingType:DeheadingReportingTypeEnum;
    productionLogId?:number;
    createdUser?:string
     constructor(workOrderNo:string,date: Date,plantId:number,quantity:number,prodInvId?:number,remarks?:string,quality?:QualityTypeEnum,variantId?:number,variantName?:string,reportingType?:DeheadingReportingTypeEnum,productionLogId?:number,createdUser?:string){
        this.workOrderNo=workOrderNo;
        this.date=date;
        this.plantId=plantId;
        this.quantity=quantity;
        this.prodInvId=prodInvId;
        this.remarks=remarks;
        this.quality=quality;
        this.variantId=variantId;
        this.variantName=variantName;
        this.reportingType=reportingType;
        this.productionLogId=productionLogId;
        this.createdUser=createdUser
    }
}